import React from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const ScoreBarComponent = ({ value }) => {
    const getGradientColor = (value) => {
      const red = value <= 50 ? 255 : Math.round((255 * (100 - value)) / 50);
      const green = value <= 50 ? Math.round((255 * value) / 50) : 255;
      const blue = 0;
      return `rgb(${red}, ${green}, ${blue})`;
    };

    // const getGradientColor = (value) => {
    //     const green = Math.round((255 * (100 - value)) / 100);
    //     const red = Math.round((255 * value) / 100);
    //     return `rgb(${red}, ${green}, 0)`;
    //   };
  
    const scoreBarStyle = {

      marginTop: '30px',
      width: '100%',
      height: '10px',
      background: `linear-gradient(to right, 
        #f44336 0%, 
        ${getGradientColor(50)} 50%, 
        #4caf50 100%)`,
      position: 'relative',
      borderRadius: '5px'
    };
  
    const tagStyle = {
      position: 'absolute',
      top: '-30px',
      left: `${value}%`,
      transform: 'translateX(-50%)',
      padding: '4px',
      color: "#5ea0d4",
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
    };
  
    const textStyle = {
      position: 'absolute',
      fontSize: '18px', // Ajusta el tamaño del icono aquí
      right: '10px',
      top: '-18px',
      fontWeight: 'bold',
    };

    const compenentStyle = {
        //padding: '15px',
        padding: '12px',
        marginLeft: '10px',
        marginRight: '10px'
    }
  
    return (
      <div style={compenentStyle}>
        <div style={scoreBarStyle}>
          <div style={tagStyle}>
            <LocationOnIcon/>
            <span style={textStyle}>{value}</span>
          </div>
        </div>
      </div>
    );
  };

export default ScoreBarComponent;